/**
 * Bundle builder — handoff UI; prices from Shopify 12-pack variant data only.
 * Qty steps by tray (cans_per_pack). Cart qty = trays selected per flavor.
 */
(function () {
  'use strict';

  const root = document.querySelector('.zzai-bundle');
  if (!root) return;

  const planDiscountsEl = document.getElementById('zzai-bundle-plan-discounts');

  const state = {
    tierId: null,
    targetCans: 24,
    cans: {},
    purchase: 'once',
    planId: null
  };

  let flavors = [];
  let tiers = [];
  let marks = [];
  let planDiscounts = {};
  let defaultPlanId = null;
  let cansPerPack = 12;
  let volumeTiers = [];
  let showBundleMarketing = true;
  let hasBundleSavings = false;
  let labels = {};
  let trayPreview = null;
  let trayLastSig = '';
  let summaryInView = false;
  let freeQty = false;
  const FREE_MAX_TRAYS = 200;

  const TRAY_ORDER = ['zobo', 'obi', 'chapman', 'tamtam'];
  const TRAY_LABEL = { zobo: 'Zobo', obi: 'Obì', chapman: 'Chapman', tamtam: 'TamTam' };
  const TRAY_CASE_SVG = '';
  const TRAY_CASE_CANS =
    '<div class="bp-tray-can-pack" aria-hidden="true">' +
    Array.from({ length: 12 }, () => '<span class="bp-tray-can-mini"></span>').join('') +
    '</div>' +
    '<div class="bp-tray-case-foot" aria-hidden="true"></div>';

  const TRAY_CAN_DATASET = {
    zobo: 'canZobo',
    obi: 'canObi',
    chapman: 'canChapman',
    tamtam: 'canTamtam'
  };

  function cfg() {
    return window.ZZAI?.getConfig?.() || {};
  }

  function readLabels() {
    labels = {
      meterEmpty: root.dataset.meterEmpty || 'Build your tray',
      summaryEmpty: root.dataset.summaryEmpty || 'Build your tray.',
      meterComplete: root.dataset.meterComplete || 'Bundle complete',
      subtotal: root.dataset.lblSubtotal || 'Subtotal',
      bundleSave: root.dataset.lblBundleSave || 'Bundle savings',
      subSave: root.dataset.lblSubSave || 'Subscribe & Save',
      shipping: root.dataset.lblShipping || 'Shipping',
      shippingFree: root.dataset.shippingFree || 'Included',
      shippingDash: root.dataset.shippingDash || '—',
      total: root.dataset.lblTotal || 'Total',
      addDefault: root.dataset.addDefault || 'Add bundle to cart',
      progressIncomplete:
        root.dataset.progressIncomplete ||
        "You're {need} cans away.",
      progressComplete:
        root.dataset.progressComplete || 'Ready to add.',
      subPctLabel: (function (l) { l = String(cfg().subDiscountLabel || '').trim(); return !l || /%$/.test(l) ? l : l + '%'; })(),
      soldOut: root.dataset.soldOut || 'Sold out'
    };
  }

  function loadPlanDiscounts() {
    planDiscounts = {};
    if (!planDiscountsEl) return;
    try {
      const rows = JSON.parse(planDiscountsEl.textContent);
      if (!Array.isArray(rows)) return;
      rows.forEach((row) => {
        if (!row || row.id == null) return;
        const list = Number(row.list);
        const plan = Number(row.plan);
        if (list > 0 && plan < list) {
          planDiscounts[String(row.id)] = ((list - plan) / list) * 100;
        }
      });
    } catch {
      planDiscounts = {};
    }
  }

  function initFromDom() {
    cansPerPack = parseInt(root.dataset.cansPerPack, 10) || 12;
    freeQty = root.dataset.freeQty === 'true';
    volumeTiers = [1, 2, 3]
      .map((number) => ({
        qty: parseInt(root.dataset[`tier${number}Qty`], 10) || 0,
        pct: parseFloat(root.dataset[`tier${number}Pct`]) || 0
      }))
      .filter((tier) => tier.qty > 0)
      .sort((a, b) => a.qty - b.qty);
    showBundleMarketing = root.dataset.showBundleMarketing !== 'false';
    hasBundleSavings = root.dataset.hasBundleSavings === 'true';
    defaultPlanId = root.dataset.defaultPlanId || null;
    state.planId = defaultPlanId;

    tiers = Array.from(root.querySelectorAll('.bp-tier')).map((btn) => ({
      id: btn.dataset.tierId,
      target: parseInt(btn.dataset.targetCans, 10) || 0,
      el: btn
    }));

    marks = Array.from(root.querySelectorAll('.bp-mark')).map((el) => ({
      at: parseInt(el.dataset.cans, 10) || 0,
      tierPct: parseFloat(el.dataset.tierPct) || 0,
      el
    }));

    flavors = Array.from(root.querySelectorAll('.bp-flavor')).map((card) => {
      const sku = card.dataset.sku || '';
      state.cans[sku] = 0;
      return {
        sku,
        el: card,
        variantId: parseInt(card.dataset.variantId, 10),
        packPriceCents: parseInt(card.dataset.priceCents, 10) || 0,
        planIds: String(card.dataset.planIds || '')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean),
        requiresPlan: card.dataset.requiresPlan === 'true',
        available: card.dataset.available !== 'false',
        name: card.dataset.name || sku,
        profile: card.dataset.profile || '',
        canImg: card.dataset.canImg || ''
      };
    });

    const commonPlanIds = flavors
      .filter((flavor) => flavor.available && flavor.planIds.length > 0)
      .reduce(
        (common, flavor, index) =>
          index === 0 ? flavor.planIds : common.filter((id) => flavor.planIds.includes(id)),
        []
      );
    if (!defaultPlanId || !commonPlanIds.includes(String(defaultPlanId))) {
      defaultPlanId = commonPlanIds[0] || null;
      state.planId = defaultPlanId;
    }

    trayPreview = document.getElementById('bp-tray-preview');

    const activeTier = tiers.find((t) => t.el.classList.contains('active')) || tiers[0];
    if (activeTier) {
      state.tierId = activeTier.id;
      state.targetCans = activeTier.target;
    }
    if (freeQty) state.targetCans = FREE_MAX_TRAYS * cansPerPack;
  }

  /** Free mode: any whole number of trays is a complete bundle. */
  function isFull(cans) {
    if (freeQty) return cans > 0 && trayAligned();
    return cans === state.targetCans;
  }

  /** Free mode: the next tier threshold (in cans) the meter fills toward, or null past the last. */
  function nextTierCans(cans) {
    const trays = cansPerPack > 0 ? cans / cansPerPack : 0;
    const next = volumeTiers.find((t) => t.pct > 0 && trays < t.qty);
    return next ? next.qty * cansPerPack : null;
  }

  function setMobileDockHidden(hidden) {
    const dock = root.querySelector('[data-bundle-mobile-dock]');
    if (!dock) return;
    dock.classList.toggle('is-hidden', !!hidden);
    dock.classList.toggle('is-visible', !hidden);
  }

  function updateMobileDock(totals, canAdd) {
    const dock = root.querySelector('[data-bundle-mobile-dock]');
    if (!dock) return;
    const targetCases = cansPerPack > 0 ? state.targetCans / cansPerPack : 0;
    const currentCases = cansPerPack > 0 ? totalCans() / cansPerPack : 0;
    const countEl = document.getElementById('bp-mobile-count');
    const totalEl = document.getElementById('bp-mobile-total');
    const addBtn = document.getElementById('bundle-mobile-add');
    if (countEl) {
      countEl.textContent = freeQty
        ? Math.floor(currentCases) + ' ' + (currentCases === 1 ? 'tray' : 'trays')
        : Math.floor(currentCases) + ' / ' + Math.floor(targetCases) + ' ' + (targetCases === 1 ? 'tray' : 'trays');
    }
    if (totalEl) totalEl.textContent = window.ZZAI.fmt(canAdd ? totals.grand : totals.subtotalCents);
    if (addBtn) {
      addBtn.disabled = !canAdd;
      addBtn.textContent = canAdd ? 'Add to cart' : 'Build';
    }
    setMobileDockHidden(summaryInView);
  }

  function totalCans() {
    return flavors.reduce((sum, f) => sum + (state.cans[f.sku] || 0), 0);
  }

  function packsForSku(sku) {
    const cans = state.cans[sku] || 0;
    return cansPerPack > 0 ? cans / cansPerPack : 0;
  }

  function tierPctForTrays(trays) {
    if (!showBundleMarketing) return 0;
    return volumeTiers.reduce((pct, tier) => (trays >= tier.qty ? tier.pct : pct), 0);
  }

  /** Highest configured percentage whose minimum tray quantity is met. */
  function bundleTierPct() {
    const trays = cansPerPack > 0 ? totalCans() / cansPerPack : 0;
    return tierPctForTrays(trays);
  }

  /** Savings % that applies at a meter mark threshold. */
  function savingsPctAtCans(cans) {
    if (!hasBundleSavings) return 0;
    const trays = cansPerPack > 0 ? cans / cansPerPack : 0;
    return volumeTiers.reduce((pct, tier) => (trays >= tier.qty ? tier.pct : pct), 0);
  }

  function subDiscountPct() {
    const pricingPlanId = state.planId != null ? state.planId : defaultPlanId;
    const id = pricingPlanId != null ? String(pricingPlanId) : '';
    if (id && Object.prototype.hasOwnProperty.call(planDiscounts, id)) {
      return planDiscounts[id];
    }
    const pct = parseFloat(cfg().subDiscount);
    return Number.isFinite(pct) ? pct : 0;
  }

  /** List subtotal = sum of (trays × Shopify 12-pack variant price). */
  function listSubtotalCents() {
    return flavors.reduce((sum, f) => {
      const packs = packsForSku(f.sku);
      return sum + Math.round(packs * f.packPriceCents);
    }, 0);
  }

  /** Tier discount, then subscribe — same order as pre-rebuild bundle + PDP. */
  function calcTotals() {
    const cans = totalCans();
    const subtotalCents = listSubtotalCents();
    const tierPct = bundleTierPct();
    const subPct = subDiscountPct();
    const afterTier = flavors.reduce((sum, f) => {
      const packs = packsForSku(f.sku);
      const offEach = Math.round((f.packPriceCents * tierPct) / 100);
      return sum + Math.round(packs * (f.packPriceCents - offEach));
    }, 0);
    const afterSub = Math.round(afterTier * (1 - subPct / 100));
    const bundleSaveCents = subtotalCents - afterTier;
    const subSaveCents = afterTier - afterSub;
    const grand = state.purchase === 'subscribe' ? afterSub : afterTier;
    const savedCents = subtotalCents - grand;

    return {
      cans,
      subtotalCents,
      afterTier,
      afterSub,
      grand,
      tierPct,
      subPct,
      bundleSaveCents,
      subSaveCents,
      savedCents
    };
  }

  function meterFillPct(cans, target) {
    if (!target || target <= 0) return 0;
    return Math.min(100, (cans / target) * 100);
  }

  function summaryEmptyText(target) {
    return (labels.summaryEmpty || 'Pick your flavors to fill {target} cans.').replace(
      /\{target\}/g,
      String(target)
    );
  }

  function syncTierDataset() {
    if (state.tierId) root.dataset.tier = state.tierId;
  }

  function updateMeterStatus(cans, target, full, totals) {
    if (cans === 0) return labels.meterEmpty || 'Build your tray';
    if (freeQty) {
      const trays = cansPerPack > 0 ? cans / cansPerPack : 0;
      const next = nextTierCans(cans);
      const pct = tierPctForTrays(trays);
      if (next) {
        const nextTier = volumeTiers.find((t) => t.qty * cansPerPack === next);
        const more = (next - cans) / cansPerPack;
        return trays + (trays === 1 ? ' tray' : ' trays') + '. Add <span class="accent">' + more + '</span> more for ' + nextTier.pct + '% off';
      }
      return trays + ' trays, <span class="accent">' + pct + '% off</span>';
    }
    if (!full) {
      const need = Math.max(0, target - cans);
      return "You're <span class=\"accent\">" + need + '</span> cans away';
    }
    if (state.purchase === 'subscribe' && totals.subPct > 0 && totals.subSaveCents > 0) {
      return 'Subscribe saves <span class="accent">' + labels.subPctLabel + '</span>';
    }
    return '<span class="accent">' + labels.meterComplete + '</span>';
  }

  function setLineVisible(lineEl, show) {
    if (!lineEl) return;
    if (show) {
      lineEl.removeAttribute('hidden');
      lineEl.style.display = '';
    } else {
      lineEl.setAttribute('hidden', '');
      lineEl.style.display = 'none';
    }
  }

  function progressHtml(tpl, vars) {
    let html = tpl;
    Object.keys(vars).forEach((key) => {
      html = html.split('{' + key + '}').join('<strong>' + vars[key] + '</strong>');
    });
    return '<span>' + html + '</span>';
  }

  function setQty(sku, n) {
    const f = flavors.find((x) => x.sku === sku);
    if (!f || !f.available) return;
    if (n < 0) return;
    if (n > 0 && n % cansPerPack !== 0) return;
    const total = totalCans();
    const other = total - (state.cans[sku] || 0);
    if (n > state.targetCans) return;
    if (other + n > state.targetCans) return;
    if (freeQty && other + n > FREE_MAX_TRAYS * cansPerPack) return;
    state.cans[sku] = n;
    updateUI();
  }

  function evenMix() {
    const available = flavors.filter((flavor) => flavor.available);
    if (freeQty) {
      return available.slice(0, 4).map((flavor) => ({ flavor, trays: 1 }));
    }
    const trayCount = cansPerPack > 0 ? Math.floor(state.targetCans / cansPerPack) : 0;
    if (!available.length || trayCount <= 0) return [];
    const base = Math.floor(trayCount / available.length);
    const remainder = trayCount % available.length;
    return available.map((flavor, index) => ({
      flavor,
      trays: base + (index < remainder ? 1 : 0)
    }));
  }

  function applyEvenMix() {
    const mix = evenMix();
    flavors.forEach((flavor) => {
      state.cans[flavor.sku] = 0;
    });
    mix.forEach((entry) => {
      state.cans[entry.flavor.sku] = entry.trays * cansPerPack;
    });
    updateUI();
  }

  function selectTier(tierId) {
    const tier = tiers.find((t) => t.id === tierId);
    if (!tier) return;
    if (tier.id === state.tierId) {
      applyEvenMix();
      return;
    }
    state.tierId = tier.id;
    state.targetCans = tier.target;
    tiers.forEach((t) => {
      const selected = t.id === tierId;
      t.el.classList.toggle('active', selected);
      t.el.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    syncTierDataset();
    applyEvenMix();
  }

  function setPurchase(type) {
    const next = type === 'subscribe' ? 'subscribe' : 'once';
    state.purchase = next;
    state.planId = next === 'subscribe' ? defaultPlanId : null;
    const btnOnce = document.getElementById('bp-pt-once');
    const btnSub = document.getElementById('bp-pt-subscribe');
    if (btnOnce) btnOnce.classList.toggle('active', next === 'once');
    if (btnSub) btnSub.classList.toggle('active', next === 'subscribe');
    updateUI();
  }

  function updateTierPricing() {
    const minPack = Math.min(...flavors.map((f) => f.packPriceCents).filter((p) => p > 0));
    if (!Number.isFinite(minPack) || minPack <= 0) return;
    tiers.forEach((t) => {
      const fromEl = root.querySelector('[data-tier-from="' + t.id + '"]');
      const perEl = root.querySelector('[data-tier-percan="' + t.id + '"]');
      const packCount = cansPerPack > 0 ? t.target / cansPerPack : 0;
      const tierPct = tierPctForTrays(packCount);
      const listTotal = Math.round(packCount * minPack);
      const discountedTotal = Math.round(listTotal * (1 - tierPct / 100));
      if (fromEl) fromEl.textContent = 'from ' + window.ZZAI.fmt(discountedTotal);
      if (perEl) perEl.textContent = '';
    });
  }

  function trayAligned() {
    const selected = flavors.filter((f) => (state.cans[f.sku] || 0) > 0);
    return selected.every((f) => (state.cans[f.sku] || 0) % cansPerPack === 0);
  }

  function trayCanUrl(sku) {
    const key = TRAY_CAN_DATASET[sku];
    if (key && root.dataset[key]) return 'url("' + root.dataset[key] + '")';
    const f = flavors.find((x) => x.sku === sku);
    if (f && f.canImg) return 'url("' + f.canImg + '")';
    return 'none';
  }

  function updateTrayPreview() {
    if (!trayPreview || !cansPerPack) return;
    let targetCases = state.targetCans / cansPerPack;
    if (!Number.isFinite(targetCases) || targetCases <= 0) return;

    const cases = {};
    let totalCases = 0;
    TRAY_ORDER.forEach((sku) => {
      const n = state.cans[sku] || 0;
      const c = Math.floor(n / cansPerPack);
      cases[sku] = c;
      totalCases += c;
    });
    if (freeQty) targetCases = Math.max(1, totalCases);

    const sig =
      targetCases +
      '|' +
      cases.zobo +
      ',' +
      cases.obi +
      ',' +
      cases.chapman +
      ',' +
      cases.tamtam;
    if (sig === trayLastSig) return;
    trayLastSig = sig;

    const tierAttr = targetCases >= 4 ? '4' : '2';
    trayPreview.dataset.tier = tierAttr;
    trayPreview.classList.toggle('complete', totalCases >= targetCases && targetCases > 0);

    const curEl = trayPreview.querySelector('.bp-tray-count .cur');
    const totalEl = trayPreview.querySelector('.bp-tray-count .total');
    if (curEl) curEl.textContent = totalCases;
    if (totalEl) totalEl.textContent = targetCases;

    const seq = [];
    TRAY_ORDER.forEach((k) => {
      for (let i = 0; i < cases[k]; i++) seq.push(k);
    });

    const casesHost = document.getElementById('bp-tray-cases');
    if (!casesHost) return;

    if (casesHost.children.length !== targetCases) {
      casesHost.innerHTML = '';
      for (let i = 0; i < targetCases; i++) {
        const caseEl = document.createElement('div');
        caseEl.className = 'bp-tray-case';
        caseEl.innerHTML = TRAY_CASE_SVG + TRAY_CASE_CANS;
        casesHost.appendChild(caseEl);
      }
    }

    for (let i = 0; i < targetCases; i++) {
      const caseEl = casesHost.children[i];
      const flavor = seq[i];
      if (flavor) {
        caseEl.dataset.flavor = flavor;
        caseEl.style.setProperty('--can-img', trayCanUrl(flavor));
        caseEl.style.setProperty('--case-color', 'var(--zzai-' + flavor + ')');
        caseEl.classList.add('filled');
      } else {
        caseEl.classList.remove('filled');
        caseEl.removeAttribute('data-flavor');
        caseEl.style.removeProperty('--can-img');
        caseEl.style.removeProperty('--case-color');
      }
    }

    const legend = document.getElementById('bp-tray-legend');
    if (!legend) return;
    if (totalCases === 0) {
      legend.innerHTML =
        '<span class="bp-tray-legend-item" style="opacity:.65;font-style:italic;text-transform:none;letter-spacing:0;font-weight:600">Tap <strong style="font-weight:800">+</strong> below to add a tray</span>';
      return;
    }
    legend.innerHTML = '';
    TRAY_ORDER.forEach((k) => {
      if (!cases[k]) return;
      const item = document.createElement('span');
      item.className = 'bp-tray-legend-item';
      const caseTxt = cases[k] === 1 ? '1 tray' : cases[k] + ' trays';
      item.innerHTML =
        '<span class="bp-tray-legend-sw" style="--sw:var(--zzai-' +
        k +
        ')"></span>' +
        '<span>' +
        TRAY_LABEL[k] +
        ' <span class="n">' +
        caseTxt +
        '</span></span>';
      legend.appendChild(item);
    });
  }

  function updateUI() {
    const totals = calcTotals();
    const cans = totals.cans;
    const target = freeQty ? (nextTierCans(cans) || cans || cansPerPack) : state.targetCans;
    const full = isFull(cans);
    const fillPct = meterFillPct(cans, target);

    const meterEl = document.getElementById('bp-meter');
    if (meterEl) {
      meterEl.classList.toggle('bp-meter--selection-only', !hasBundleSavings);
    }

    const trackFill = document.getElementById('bp-track-fill');
    if (trackFill) trackFill.style.width = fillPct + '%';

    marks.forEach((m) => {
      const pct = m.tierPct > 0 ? m.tierPct : savingsPctAtCans(m.at);
      const hit = hasBundleSavings && cans >= m.at && pct > 0;
      m.el.classList.toggle('hit', hit);
      m.el.hidden = freeQty || !hasBundleSavings || pct <= 0;
    });

    const meterStatus = document.getElementById('bp-meter-status');
    if (meterStatus) {
      meterStatus.innerHTML = updateMeterStatus(cans, target, full, totals);
    }

    flavors.forEach((f) => {
      const n = state.cans[f.sku] || 0;
      const qtyEl = f.el.querySelector('[data-qty-val]');
      if (qtyEl) qtyEl.textContent = freeQty && cansPerPack > 0 ? n / cansPerPack : n;
      f.el.classList.toggle('has-qty', n > 0);
      const dec = f.el.querySelector('[data-qty-dec]');
      const inc = f.el.querySelector('[data-qty-inc]');
      if (dec) dec.disabled = n === 0;
      if (inc) inc.disabled = !f.available || totalCans() >= (freeQty ? FREE_MAX_TRAYS * cansPerPack : state.targetCans);
    });

    const priceOT = document.getElementById('bp-price-onetime');
    const priceSub = document.getElementById('bp-price-subscribe');
    if (priceOT) priceOT.textContent = window.ZZAI.fmt(totals.afterTier);
    if (priceSub) priceSub.textContent = window.ZZAI.fmt(totals.afterSub);

    const emptyEl = document.getElementById('bp-summary-empty');
    const itemsEl = document.getElementById('bp-sum-items');
    const selected = flavors.filter((f) => (state.cans[f.sku] || 0) > 0);

    if (emptyEl) {
      emptyEl.hidden = selected.length > 0;
      if (selected.length === 0) emptyEl.textContent = summaryEmptyText(target);
    }
    if (itemsEl) {
      itemsEl.innerHTML = '';
      itemsEl.hidden = selected.length === 0;
      selected.forEach((f) => {
        const c = state.cans[f.sku] || 0;
        const packs = packsForSku(f.sku);
        const lineCents = Math.round(packs * f.packPriceCents);
        const row = document.createElement('div');
        row.className = 'bp-sum-item';
        row.innerHTML =
          '<span class="sw" data-sku="' +
          f.sku +
          '" style="--ic: var(--sku-color)"></span>' +
          '<div><div class="nm">' +
          f.name +
          '</div><div class="qt">' +
          c +
          ' cans · ' +
          f.profile +
          '</div></div>' +
          '<div class="pr">' +
          window.ZZAI.fmt(lineCents) +
          '</div>';
        itemsEl.appendChild(row);
      });
    }

    const valSub = document.getElementById('bp-val-subtotal');
    const lblSub = document.getElementById('bp-lbl-subtotal');
    if (lblSub) lblSub.textContent = labels.subtotal + ' (' + cans + ' cans)';
    if (valSub) valSub.textContent = window.ZZAI.fmt(totals.subtotalCents);

    const lineBundle = document.getElementById('bp-line-bundle-save');
    const lblBundle = document.getElementById('bp-lbl-bundle-save');
    const valBundle = document.getElementById('bp-val-bundle-save');
    const showBundleLine =
      selected.length > 0 &&
      full &&
      hasBundleSavings &&
      totals.tierPct > 0 &&
      totals.bundleSaveCents > 0;
    setLineVisible(lineBundle, showBundleLine);
    if (lblBundle && valBundle) {
      if (showBundleLine) {
        lblBundle.textContent = labels.bundleSave + ' (' + totals.tierPct + '%)';
        valBundle.textContent = '−' + window.ZZAI.fmt(totals.bundleSaveCents);
      } else {
        valBundle.textContent = '';
      }
    }

    const lineSub = document.getElementById('bp-line-sub-save');
    const lblSubSave = document.getElementById('bp-lbl-sub-save');
    const valSubSave = document.getElementById('bp-val-sub-save');
    const showSubLine =
      selected.length > 0 &&
      full &&
      state.purchase === 'subscribe' &&
      totals.subPct > 0 &&
      totals.subSaveCents > 0;
    setLineVisible(lineSub, showSubLine);
    if (lblSubSave && valSubSave) {
      if (showSubLine) {
        lblSubSave.textContent = labels.subSave + ' (' + labels.subPctLabel + ')';
        valSubSave.textContent = '−' + window.ZZAI.fmt(totals.subSaveCents);
      } else {
        valSubSave.textContent = '';
      }
    }

    const valShip = document.getElementById('bp-val-shipping');
    if (valShip) valShip.textContent = cans > 0 ? labels.shippingFree : labels.shippingDash;

    const valTotal = document.getElementById('bp-val-total');
    if (valTotal) {
      valTotal.textContent = window.ZZAI.fmt(full ? totals.grand : totals.subtotalCents);
    }

    const progress = document.getElementById('bp-progress');
    if (progress) {
      if (cans === 0) {
        progress.innerHTML = '<span>Build your tray.</span>';
      } else if (!full && !freeQty) {
        const need = Math.abs(target - cans);
        progress.innerHTML = progressHtml(labels.progressIncomplete, {
          current: cans,
          target: target,
          need: need
        });
      } else if (!trayAligned()) {
        progress.innerHTML =
          '<span>Each flavor must be in <strong>' +
          cansPerPack +
          '-can</strong> tray increments before checkout.</span>';
      } else if (state.purchase === 'subscribe' && totals.subPct > 0 && totals.subSaveCents > 0) {
        progress.innerHTML = '<span>Subscribe saves <strong>' + labels.subPctLabel + '</strong>.</span>';
      } else {
        progress.innerHTML = progressHtml(labels.progressComplete, {
          saved: window.ZZAI.fmt(totals.savedCents)
        });
      }
    }

    const addBtn = document.getElementById('bundle-add');
    const addLabel = document.getElementById('bp-add-label');
    const canAdd = canCheckout();
    if (addBtn) addBtn.disabled = !canAdd;
    if (addLabel) {
      if (freeQty && cans === 0) {
        addLabel.textContent = labels.addDefault;
      } else if (!full && !freeQty) {
        const need = target - cans;
        addLabel.textContent =
          need > 0 ? 'Add ' + need + ' more cans' : 'Remove ' + Math.abs(need) + ' cans';
      } else if (!trayAligned()) {
        addLabel.textContent = 'Use ' + cansPerPack + '-can tray increments';
      } else {
        addLabel.textContent = 'Add bundle · ' + window.ZZAI.fmt(totals.grand);
      }
    }

    updateTierPricing();
    updateTrayPreview();
    updateMobileDock(totals, canAdd);
  }

  function canCheckout() {
    const cans = totalCans();
    if (!isFull(cans)) return false;
    if (!trayAligned()) return false;
    const selected = flavors.filter((f) => (state.cans[f.sku] || 0) > 0);
    if (!selected.length) return false;
    if (selected.some((f) => !f.available || !f.variantId)) return false;
    if (state.purchase === 'subscribe') {
      if (!state.planId) return false;
      if (selected.some((f) => !f.planIds.includes(String(state.planId)))) return false;
    }
    if (selected.some((f) => f.requiresPlan) && state.purchase !== 'subscribe') return false;
    return true;
  }

  async function addToCart() {
    if (!canCheckout()) return;

    const selected = flavors.filter((f) => (state.cans[f.sku] || 0) > 0);
    if (selected.some((f) => f.requiresPlan) && state.purchase !== 'subscribe') {
      setPurchase('subscribe');
      if (!canCheckout()) return;
    }

    const items = selected.map((f) => {
      const item = {
        id: f.variantId,
        quantity: packsForSku(f.sku)
      };
      if (state.purchase === 'subscribe' && state.planId) {
        const plan = Number(state.planId);
        item.selling_plan = Number.isSafeInteger(plan) && plan > 0 ? plan : String(state.planId);
      }
      return item;
    });

    const addBtn = document.getElementById('bundle-add');
    const addLabel = document.getElementById('bp-add-label');
    const mobileAddBtn = document.getElementById('bundle-mobile-add');
    if (addBtn) addBtn.disabled = true;
    if (mobileAddBtn) mobileAddBtn.disabled = true;
    if (addLabel) addLabel.textContent = 'Adding...';

    try {
      const res = await window.ZZAI.jsonPost(window.ZZAI.cartAddJsUrl(), { items });
      const text = await res.text();
      if (!res.ok) throw new Error(text.slice(0, 240) || res.statusText);
      let body = {};
      try {
        body = text ? JSON.parse(text) : {};
      } catch {
        body = {};
      }
      if (body.status >= 400) throw new Error(body.description || body.message || 'Could not add to cart');

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: null,
            sourceId: 'zzai-bundle',
            data: {
              variantId: String(items[0]?.id || ''),
              source: 'bundle-add'
            }
          }
        })
      );
      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer();
      } else {
        const cartRes = await fetch(window.ZZAI.cartJsUrl(), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        const cart = cartRes.ok ? await cartRes.json() : { item_count: 0 };
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'zzai-bundle-refresh',
            data: { itemCount: cart.item_count || 0 }
          }
        }));
      }
    } catch (err) {
      console.error('[zzai-bundle]', err);
      window.alert(err.message || 'Could not add this bundle to cart.');
    } finally {
      updateUI();
    }
  }

  function bind() {
    tiers.forEach((t) => {
      t.el.addEventListener('click', () => selectTier(t.id));
    });

    flavors.forEach((f) => {
      f.el
        .querySelector('[data-qty-inc]')
        ?.addEventListener('click', () => setQty(f.sku, (state.cans[f.sku] || 0) + cansPerPack));
      f.el
        .querySelector('[data-qty-dec]')
        ?.addEventListener('click', () => setQty(f.sku, (state.cans[f.sku] || 0) - cansPerPack));
    });

    document.getElementById('bp-pt-once')?.addEventListener('click', () => setPurchase('once'));
    document.getElementById('bp-pt-subscribe')?.addEventListener('click', () => setPurchase('subscribe'));
    document.getElementById('bundle-add')?.addEventListener('click', addToCart);
    document.getElementById('bundle-mobile-add')?.addEventListener('click', addToCart);
    root.querySelector('[data-bundle-mobile-edit]')?.addEventListener('click', () => {
      const target = root.querySelector('.bp-grid') || root.querySelector('.bp-tiers') || root;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    const summary = root.querySelector('.bp-summary');
    const dock = root.querySelector('[data-bundle-mobile-dock]');
    if (summary && dock && typeof IntersectionObserver !== 'undefined') {
      const obs = new IntersectionObserver(
        (entries) => {
          summaryInView = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0.18);
          setMobileDockHidden(summaryInView);
        },
        { threshold: [0, 0.18, 0.45] }
      );
      obs.observe(summary);
    }
  }

  function boot() {
    readLabels();
    loadPlanDiscounts();
    initFromDom();
    syncTierDataset();
    applyEvenMix();
    bind();

    if (flavors.some((f) => f.requiresPlan)) {
      setPurchase('subscribe');
    } else {
      setPurchase('once');
    }
    updateUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
